import { Checkbox, Drawer, Flex, Link, Text } from '@servicetitan/anvil2';
import { useState } from 'react';
import { TurnsDisclosureText } from './TurnsDisclosureText';
import {
    useProviderConfig,
    useSecondLookIntegration,
    useSecondLookProviderName,
} from '@servicetitan/financing-workflow-shared';

export interface TurnsCoapplicationDisclosureProps {
    onChange: (agreed: boolean) => void;
}

export const TurnsCoapplicationDisclosure = ({ onChange }: TurnsCoapplicationDisclosureProps) => {
    const [showTerms, setShowTerms] = useState(false);
    const { turnsCoapplicationDisclosureText } = useProviderConfig();
    const { secondLookProvider } = useSecondLookIntegration();
    const secondLookProviderName = useSecondLookProviderName();
    const isTurnsSecondLook = secondLookProvider?.toLowerCase() === 'turns';

    return (
        <Flex direction="row">
            <Checkbox onChange={(e, state) => onChange(state?.checked ?? false)} />
            <Text>
                {turnsCoapplicationDisclosureText}{' '}
                <Link onClick={() => setShowTerms(true)}>View terms</Link>
            </Text>
            {showTerms && (
                <Drawer open onClose={() => setShowTerms(false)}>
                    <Drawer.Header>{secondLookProviderName} Financing Terms</Drawer.Header>
                    <Drawer.Content>{isTurnsSecondLook && <TurnsDisclosureText />}</Drawer.Content>
                </Drawer>
            )}
        </Flex>
    );
};
